"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSavedAddress = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const payment_js_1 = require("@broadleaf/payment-js");
/**
 * This hook is useful when saved addresses can be used as billing addresses.
 * It checks if supplied `selectedAddress` match one of the
 * customer addresses or `savedPaymentAddress`.
 *
 * The `selectedAddress` could be one of:
 * - the default user address
 * - the billing address of the existing payment on the cart (if in edit mode)
 * - the billing address of a saved payment
 * - undefined because no selection has been made
 *
 * The `paymentAddress` would be the address of a saved payment (PaymentAccount)
 *
 * @param savedAddresses List of customer addresses for a customer
 * @param selectedAddress The currently selected address
 * @param savedPaymentAddress The address on the active payment
 * @returns
 */
const useIsSavedAddress = ({ savedAddresses, selectedAddress, savedPaymentAddress }) => {
    const [usingSavedAddress, setUsingSavedAddress] = (0, react_1.useState)(!!(0, payment_js_1.findMatchingSavedAddress)(savedAddresses, selectedAddress) ||
        (0, payment_js_1.areAddressesEquivalent)(savedPaymentAddress, selectedAddress));
    (0, react_1.useEffect)(() => {
        setUsingSavedAddress(!!(0, payment_js_1.findMatchingSavedAddress)(savedAddresses, selectedAddress) ||
            (0, payment_js_1.areAddressesEquivalent)(savedPaymentAddress, selectedAddress));
    }, [selectedAddress, savedAddresses, savedPaymentAddress]);
    return usingSavedAddress;
};
exports.useIsSavedAddress = useIsSavedAddress;
//# sourceMappingURL=use-is-saved-address.js.map